export const LocalStorageKeys = {
  useCache: "useCache",
  threadsTimeFrom: "threadsTimeFrom",
  authSession: "authSession",
  cacheResetPending: "cacheResetPending",
};
